import React, { useState, Component } from 'react';
import { CheckIcon, XCircleIcon, ArrowUpRightIcon } from 'lucide-react';
export const PricingSection = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Create email body with form data
    const subject = encodeURIComponent(`Pricing Details Request from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nCompany: ${formData.company}\nEmail: ${formData.email}\nPhone: ${formData.phone}`);
    // Open mailto link in new window
    window.open(`mailto:info@salessource.nl?subject=${subject}&body=${body}`);
    // Show confirmation and reset form
    alert('Thank you for your interest! Your email client should open with your request details.');
    setShowForm(false);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: ''
    });
  };
  const pricingModels = [{
    name: 'Outsourced Conference Sales',
    description: 'Ideal for established events looking to maximize sponsorship revenue',
    features: ['Retainer + Commission Model', 'Full sponsorship sales cycle management', 'Dedicated account manager', 'Weekly progress reports', 'Sponsor relationship management', 'Contract negotiation & closing', 'Basic sponsor activation support'],
    notIncluded: ['Premium sponsor prospecting', 'Custom sponsorship package design', 'On-site sponsor management']
  }];
  return <section id="pricing" className="py-16 md:py-24 bg-[#f5f5f5]" data-id="element-253">
      <div className="container mx-auto px-6" data-id="element-254">
        <div className="mb-5" data-id="element-255">
          <span className="text-[#1B2A4A] font-medium inline-flex items-center gap-2 bg-white/70 px-4 py-1.5 rounded-full shadow-sm" data-id="element-256">
            <div className="w-6 h-6 bg-[#B87333] rounded-sm" data-id="element-257"></div>
            Pricing
          </span>
        </div>
        <div className="mb-16" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1B2A4A] mb-6" data-id="element-259">
            Transparent{' '}
            <span className="font-serif italic text-[#B87333]" data-id="element-260">pricing</span>{' '}
            model
          </h2>
          <p className="text-lg md:text-xl text-[#1B2A4A]/80 max-w-2xl leading-relaxed" data-id="element-261">
            Flexible pricing structure aligned with your event goals and budget
          </p>
        </div>

        {/* Pricing Models */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8 mb-10 md:mb-16" data-id="element-262">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-all h-full flex flex-col mx-auto max-w-4xl w-full transform hover:-translate-y-1 duration-300" data-id="element-263">
            <div className="bg-[#1B2A4A] p-5 md:p-8 text-white" data-id="element-264">
              <h3 className="text-2xl font-bold mb-3" data-id="element-265">
                {pricingModels[0].name}
              </h3>
              <p className="text-white/80" data-id="element-266">{pricingModels[0].description}</p>
            </div>
            <div className="p-5 md:p-8 flex-grow grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10" data-id="element-267">
              <div className="flex flex-col" data-id="element-268">
                <div className="mb-8 flex-grow" data-id="element-269">
                  <h4 className="font-bold text-[#1B2A4A] text-lg mb-5" data-id="element-270">
                    What's Included:
                  </h4>
                  <ul className="space-y-4" data-id="element-271">
                    {pricingModels[0].features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-272">
                        <span className="text-green-600 mr-3 mt-1 flex-shrink-0" data-id="element-273">
                          <CheckIcon size={18} data-id="element-274" />
                        </span>
                        <span className="text-[#1B2A4A]/70" data-id="element-275">{feature}</span>
                      </li>)}
                  </ul>
                </div>

                {pricingModels[0].notIncluded.length > 0 && <div className="mb-8" data-id="element-276">
                    <h4 className="font-bold text-[#1B2A4A] text-lg mb-5" data-id="element-277">
                      Premium Add-ons:
                    </h4>
                    <ul className="space-y-4" data-id="element-278">
                      {pricingModels[0].notIncluded.map((feature, i) => <li key={i} className="flex items-start" data-id="element-279">
                          <span className="text-[#B87333] mr-3 mt-1 flex-shrink-0" data-id="element-280">
                            <CheckIcon size={18} data-id="element-281" />
                          </span>
                          <span className="text-[#1B2A4A]/70" data-id="element-282">{feature}</span>
                        </li>)}
                    </ul>
                  </div>}

                <div className="mt-auto" data-id="element-283">
                  <a href="https://forms.gle/zspSVdBJ7eiHmqQj6" className="w-full text-center bg-[#B87333] hover:bg-[#B87333]/90 text-[#1B2A4A] font-medium py-3 px-6 rounded-md transition-all flex items-center justify-center gap-2 shadow-md" data-id="element-284">
                    Request Pricing Details <ArrowUpRightIcon size={18} data-id="element-285" />
                  </a>
                </div>
              </div>
              <div className="flex items-center justify-center" data-id="element-286">
                <div className="rounded-lg overflow-hidden shadow-md border border-gray-100 h-full w-full" data-id="element-287">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oXNEkFmiwrWLWJpTPjkad2/20230125_175051.jpg" alt="Conference venue with purple lighting" className="w-full h-full object-cover" data-id="element-288" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Email Form Modal */}
      {showForm && <div className="fixed inset-0 bg-[#1B2A4A]/60 flex items-center justify-center z-50 p-4" data-id="element-289">
          <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-8 relative" data-id="element-290">
            <button onClick={() => setShowForm(false)} className="absolute top-4 right-4 text-[#1B2A4A]/50 hover:text-[#1B2A4A] transition-colors" data-id="element-291">
              <XCircleIcon size={24} data-id="element-292" />
            </button>
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6" data-id="element-293">
              Request Pricing Details
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-294">
              <div data-id="element-295">
                <label htmlFor="name" className="block text-sm font-medium text-[#1B2A4A]/70 mb-1" data-id="element-296">
                  Name:
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#B87333] transition-all" data-id="element-297" />
              </div>
              <div data-id="element-298">
                <label htmlFor="company" className="block text-sm font-medium text-[#1B2A4A]/70 mb-1" data-id="element-299">
                  Company:
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#B87333] transition-all" data-id="element-300" />
              </div>
              <div data-id="element-301">
                <label htmlFor="email" className="block text-sm font-medium text-[#1B2A4A]/70 mb-1" data-id="element-302">
                  Email:
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#B87333] transition-all" data-id="element-303" />
              </div>
              <div data-id="element-304">
                <label htmlFor="phone" className="block text-sm font-medium text-[#1B2A4A]/70 mb-1" data-id="element-305">
                  Phone number:
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#B87333] transition-all" data-id="element-306" />
              </div>
              <button type="submit" className="w-full mt-6 bg-[#B87333] hover:bg-[#B87333]/90 text-[#1B2A4A] font-medium py-3 px-6 rounded-md transition-all flex items-center justify-center gap-2 shadow-md" data-id="element-307">
                Submit Request <ArrowUpRightIcon size={18} data-id="element-308" />
              </button>
            </form>
          </div>
        </div>}
    </section>;
};